import { createFileRoute, redirect } from "@tanstack/react-router";

/** Rota antiga (lista do dia): a lista vive no painel lateral da Agenda. */
export const Route = createFileRoute("/app/atendimento/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/agenda" });
  },
});
